import { useAppSelector } from "@/shared/hooks";
import type { SectionKey } from "@/features/hr/hiring";
import AddressesForm from "./addresses/AddressesForm";
import BankingForm from "./banking/BankingForm";
import ContactsForm from "./contacts/ContactForm";
import ContractForm from "./contract/ContractForm";
import EducationList from "./education/EducationList";
import ExperienceList from "./experience/ExperienceList";
import GeneralForm from "./general/GeneralForm";
import IdDocumentsForm from "./id-documents/IdDocumentsForm";
import SocialCategoriesList from "./social-categories/SocialCategoriesList";

interface Props {
  section: SectionKey;
  token: string;
  onNext: () => void;
  isChief?: boolean;
}

export default function SectionRenderer({ section, token, onNext, isChief }: Props) {
  const isResident = useAppSelector((s) => s.completeness.is_resident);

  switch (section) {
    case "personal_data":
      return <GeneralForm token={token} onNext={onNext} isChief={isChief} />;
    case "contacts":
      return <ContactsForm token={token} onNext={onNext} isChief={isChief} />;
    case "addresses":
      return <AddressesForm token={token} onNext={onNext} />;
    case "id_documents":
      return <IdDocumentsForm token={token} isResident={isResident ?? undefined} onNext={onNext} />;
    case "banking":
      return <BankingForm token={token} onNext={onNext} />;
    case "education":
      return <EducationList token={token} onNext={onNext} />;
    case "experience":
      return <ExperienceList token={token} onNext={onNext} />;
    case "bessrochnyi_contract":
      return <ContractForm token={token} onNext={onNext} />;
    case "social_categories":
      return <SocialCategoriesList token={token} />;
    default:
      return null;
  }
}
